import { storeLocal } from './stores'

/**
 * Роли, у которых в справочниках (списки товаров, товарные группы, статусы, характеристики,
 * единицы измерений, модификаторы, статьи, контакты) видно всё, но создавать/редактировать/
 * удалять можно только созданные самим собой записи. Бэкенд отдаёт owner_manager_id в каждом
 * элементе списка (см. App\Http\Controllers\Concerns\HasManagerOwnership::attachOwnership).
 */
export const isOwnershipRestrictedRole = (): boolean => {
    return storeLocal.get('role') === 6
}

export const canManageOwnedRecord = (record: any): boolean => {
    if (!isOwnershipRestrictedRole()) {
        return true
    }

    if (!record || record.owner_manager_id === null || record.owner_manager_id === undefined) {
        return false
    }

    return Number(record.owner_manager_id) === Number(storeLocal.get('manager_id'))
}
